import { ResourceCrudPage } from '@/components/crud/ResourceCrudPage'
import { ROUTE_TO_RESOURCE } from '@/lib/route-resources'
import { PlaceholderPage } from '@/pages/PlaceholderPage'
import { useLocation } from 'react-router-dom'

/**
 * For nav items that don't have a curated page, look the path up in
 * `ROUTE_TO_RESOURCE` and render `ResourceCrudPage` against the matching
 * backend AdminResource. Falls back to the lightweight placeholder when
 * no mapping exists.
 */
export function RouteResourceFallback() {
  const location = useLocation()
  const meta = ROUTE_TO_RESOURCE[location.pathname]

  if (meta) {
    return (
      <ResourceCrudPage
        resource={meta.resource}
        title={meta.title}
        description={meta.description}
      />
    )
  }
  return <PlaceholderPage />
}
